import { withUnauthorizedToken } from '../../../utils/auth';
import { get, post, del } from '../../../utils/api';
import { preSaveFormatComposition } from './utils';

export default {
  getItems: () => get({ url: 'cart/get', data: withUnauthorizedToken() }),
  clear: () => del({ url: 'cart/clear', data: withUnauthorizedToken() }),
  addSailplayDiscount: papabonus_charge =>
    post({ url: 'cart/add-sailplay-discount', data: withUnauthorizedToken({ papabonus_charge }) }),
  addToCart: (composition, isUpsale) =>
    post({
      url: 'cart/add',
      data: withUnauthorizedToken({
        composition: preSaveFormatComposition(composition),
        is_upsale: isUpsale,
      }),
    }),
  updateItem: params =>
    post({
      url: 'cart/update',
      data: withUnauthorizedToken({
        composition:
          params.type !== 'combo'
            ? preSaveFormatComposition([params])
            : [{ type: 'combo', count: params.count, hash: params.hash }],
      }),
    }),
  removeItem: hash => {
    // Может передаваться строка (хеш) а может массив хешей

    if (typeof hash === 'string') {
      return del({
        url: 'cart/remove',
        data: withUnauthorizedToken({ hash }),
      });
    }

    return del({
      url: 'cart/remove',
      data: withUnauthorizedToken(),
      body: { hash },
    });
  },
  postCartchangeCartSailplayDiscount: (papabonus_charge, delivery_area_id) =>
    post({
      url: 'cart/add-sailplay-discount',
      data: withUnauthorizedToken({ papabonus_charge, delivery_area_id }),
    }),
};
